import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'ticketing',
        url: '/support',
        component: 'wtTicketingState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.administrator, Roles.master, Roles.engineer, Roles.operator])
        },
        abstract: true,
        data: {
            displayName: 'Support',
            visible: false,
            isMobileVisible: true,
            isAuthenticated: true,
            isConnected: true,
            sortingOrder: 100,
            icon: 'fa-list',
            editRoles: [Roles.master, Roles.engineer],
            editButtonVisibility: () => false
        }
    },
    {
        name: 'ticketing.kanban',
        url: '/kanban',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.administrator, Roles.master, Roles.engineer, Roles.operator])
        },
        data: {
            visible: true,
            sortingOrder: 100,
            icon: 'fa-list'
        },
        views: {
            main: {
                template: `<wt-ticketing-kanban-state class="flex-directive"
                                                      ticket-view-model-list="vm.filteredTickets"
                                                      ticket-status-list="vm.ticketStatusList"
                                                      users="vm.users"
                                                      selected-ticket-view-model="vm.selectedTicketViewModel"
                                                      original-ticket-view-model="vm.originalTicketViewModel"
                                                      save-ticket="vm.saveTicket(ticket)"
                                                      is-loading="vm.isLoading"
                                                      message="vm.message">
                            </wt-ticketing-kanban-state>`
            },
            toolbar1: {
                template: '<wt-ticket-search-bar class="fill" items="vm.ticketViewModelList" filtered-items="vm.filteredTickets"></wt-ticket-search-bar>'
            }
        }
    },
    {
        name: 'ticketing.actionItems',
        url: '/actionItems',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.administrator, Roles.master, Roles.engineer, Roles.operator])
        },
        data: {
            visible: false,
            sortingOrder: 200,
            icon: 'fa-sticky-note-o',
            displayName: 'Action items'
        },
        params: {
            preFilteredId: undefined
        },
        views: {
            main: {
                template: `<wt-action-items-state class="flex-directive"
                                                  ticket-view-model-list="vm.filteredTickets"
                                                  ticket-status-list="vm.ticketStatusList"
                                                  users="vm.users"
                                                  user-pictures="vm.userPictures"
                                                  selected-ticket-view-model="vm.selectedTicketViewModel"
                                                  original-ticket-view-model="vm.originalTicketViewModel"
                                                  save-ticket="vm.saveTicket(ticket)"
                                                  is-loading="vm.isLoading"
                                                  message="vm.message">
                            </wt-action-items-state>`
            },
            toolbar1: {
                template: `<wt-ticket-search-bar class="fill" 
                                                 items="vm.ticketViewModelList" 
                                                 filtered-items="vm.filteredTickets">
                           </wt-ticket-search-bar>`
            }
        }
    }, {
        name: 'ticketing.auditReport',
        url: '/auditReport',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.administrator, Roles.master, Roles.engineer, Roles.operator])
        },
        data: {
            visible: false,
            sortingOrder: 300,
            icon: 'fa-history',
            displayName: 'Audit report'
        },
        views: {
            main: {
                template: '<wt-audit-report-state class="flex-directive" begin-date="vm.beginDate" end-date="vm.endDate" is-loading="vm.isLoading" tickets="vm.filteredTickets"></wt-audit-report-state>'
            },
            toolbar1: {
                template: '<wt-date-navigation actual-begin-date="vm.beginDate" actual-end-date="vm.endDate" initial-range="vm.initialRange"></wt-date-navigation>'
            },
            toolbar2: {
                template: `<wt-ticket-audit-search-bar class="fill" 
                                                       items="vm.ticketViewModelList" 
                                                       filtered-items="vm.filteredTickets"
                                                       ticket-statuses="vm.ticketStatusList">
                            </wt-ticket-audit-search-bar>`
            }
        }
    }, {
        name: 'ticketing.auditDashboard',
        url: '/auditDashboard',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.administrator, Roles.master, Roles.engineer, Roles.operator])
        },
        data: {
            visible: false,
            sortingOrder: 400,
            icon: 'fa-th-large',
            displayName: 'Audit dashboard'
        },
        views: {
            main: {
                template: `<wt-audit-dashboard-state class="flex-directive" 
                                                     begin-date="vm.beginDate" 
                                                     end-date="vm.endDate" 
                                                     is-loading="vm.isLoading" 
                                                     selected-period="vm.selectedPeriod"
                                                     tickets="vm.ticketViewModelList"
                                                     ticket-statuses="vm.ticketStatusList">
                           </wt-audit-dashboard-state>`
            },
            toolbar1: {
                template: '<wt-date-navigation actual-begin-date="vm.beginDate" actual-end-date="vm.endDate" frequency="vm.frequency" initial-range="vm.initialRange"></wt-date-navigation>'
            },
            toolbar2:{
                template:'<wt-audit-dashboard-picker selected-period="vm.selectedPeriod" frequency="vm.frequency"></wt-audit-dashboard-picker>'
            }
        }
    }
];

export default states;